/* eslint-disable @typescript-eslint/naming-convention */
export class LocalCredentialsModel {
	public username: string;
	public pin: string;
	public failedAttempts: number;

	public constructor(value: Partial<LocalCredentialsModel>) {
		this.username = value.username;
		this.pin = value.pin;
		this.failedAttempts = value.failedAttempts;
	}
}
